export default {
    duplicate: 'Duplicate',
    invalid: 'Invalid',
    lost: 'Lost',
    active: 'Active',
    sale: '@.capitalize:lexicon.sold.singular',
};
